let mobx = require('mobx');
// create State object
let data = {
    order: {},
}
let cancelOrderState = mobx.observable(data);

// export default loginState;
module.exports = cancelOrderState;